import React, {Dispatch, SetStateAction, useContext, useEffect, useState, useMemo} from "react";
import {Button, Grid} from "@mui/material";
import Card from "../../Components/Card";
import ResourceTable, {IGenerateColumns} from "../../Components/ResourceTable";
import {ncm} from "../../Requests";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PreserveEstruturaMercadologica from "./PreserveEstruturaMercadologica";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import useGlobalContext from "../../Hooks/useGlobalContext";
import getInitialDataFilter from "../../Components/PageFilters/initialDataFilter";
import NcmPageFilter from "../../Components/PageFilters/NcmPageFilter";

const Ncm: React.FC = () => {

    const {setLoading: setLoadingGlobal} = useGlobalContext();

    const [rechargeRequest, setRechargeRequest] = useState<number>(0);
    
    const reloadResourceTable = () => {
        setRechargeRequest(n => n + 1);
    }

    const { setFilters } = useGlobalContext();
    const { filters } = useGlobalContext();

    useEffect(() => {
        if (setFilters) {
            setFilters(getInitialDataFilter());
        }
    }, []);

    const estruturaFilters = useMemo(() => {
        return {
          page: 1, // ou use o page do seu próprio estado de paginação
          recordsPerPage: 15, // idem
          ...filters, // aqui entram os filtros do contexto atualizados com `runFilters`
        };
      }, [filters]);


    const generateColumns: IGenerateColumns = ({setLoading}) => {
        return [
            {field: 'codigo', type: 'number', headerName: 'Código', minWidth: 250, flex: 3},
            {field: 'codigo_pai', type: 'number', headerName: 'Código Pai', minWidth: 250, flex: 3},
            {field: 'descricao', headerName: 'Descrição', minWidth: 250, flex: 3},
            {field: 'inicio_vigencia', headerName: 'Início da Vigência', minWidth: 250, flex: 3},
            {field: 'fim_vigencia', headerName: 'Fim da Vigência', minWidth: 250, flex: 3},
            {field: 'status', headerName: 'Validade', minWidth: 250, flex: 3}            
        ];

    }

    return (<>
        <Grid container spacing={0.5}>
            <NcmPageFilter />
            <Card
                titleDashboard='Listagem de NCMs cadastrados na Receita Federal do Brasil'
                icon='CloudUploadIcon'
                paperConfig={{minHeight: 154}}
                marginTop='0'
                lineDividerHeader={false}
            >
                {/*{(accessProfilesOptions.length > 0) && */}
                <ResourceTable
                    request={ncm}
                    generateColumns={generateColumns}
                    pageSizeOptions={[15]}
                    getRowId={(row) => row?.identifier}
                    minHeight={60}
                    rechargeRequest={rechargeRequest}
                    autoPageSize={true}
                    filterDefinitions={() => estruturaFilters}
                />
                {/*}*/}
            </Card>

        </Grid>
    </>);
}


export default Ncm;
